<template>
       <div v-show="loaded" class="interested">
        <div class="icon-interest pt-5">
          <img src="/asset/image/icon/ico-interested.png" alt="">
        </div>
        <b class="heading pb-3">
          Beside your search, you may feel interested in the below recommended jobs.
        </b>
        <!-- <div class="pb-5 px-5">
          {{ cpLang('jd.recommend') }}
        </div> -->
        <div class="job-area">
          <Predict
            :max-predict="6"
            :positionid="String(id)"
            @failed="noPredictFunc"
            @noJobs="noPredictFunc"
            @loaded="jobLoaded"
            no-waterfall
            type="similar"
        />
        </div>
      </div>
</template>
<script>
import Predict from '~/components/search/Predict.vue'

export default {
  components: {
    Predict
  },
  props: {
    id: {
      default: null,
      type: String
    }
  },
  data: function () {
    return {
      loaded: false
    }
  },
  methods: {
    jobLoaded: function() {
      this.loaded = true
      window.dispatchEvent(new Event('resize'))
    },
    noPredictFunc: function() {
      // console.log('noPredictFunc')
      this.$emit('noPredict')
    }
  }
}
</script>
